// extracted by mini-css-extract-plugin
module.exports = {"root":"_147dfb","alternative":"_07bafb","logo":"_708c4f","info":"_ef1247","name":"_ef203c","rating":"_1941bf"};